import { defineComponent as _defineComponent } from 'vue'
import { Ref, ref } from 'vue';
import { TncDialog } from '@tencent/wphk-act-base-ui';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { useActConfigStore } from '../../store/act-config';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { targetActConfig } = useActConfigStore();
// ---- ref句柄 ----
const refTncDialog: Ref<InstanceType<typeof TncDialog> | null> = ref(null);

// ---- hooks ----
const { getBiExt } = useGlobalBi();

// 点击条款与细则
function handleViewRule() {
  refTncDialog.value?.showTncDialog();
}
// 点击查看优惠券
function handleViewCpn() {
  jumpPage.goMyCoupons({ adtag: '2024spring', delay: 500 });
}

return { __sfc: true,targetActConfig, refTncDialog, getBiExt, handleViewRule, handleViewCpn, TncDialog }
}

})